import React from 'react';
import { useTranslation } from 'react-i18next';
import BaseDataGlance from './baseGlances/baseDataGlance'



export default function Paidouts(props) {

    const { t } = useTranslation();
    return (
        <>
            <BaseDataGlance cssContentClass='paidouts-glance-body'
                cssHeadingClass='paydouts-glance-heading'
                cssIconClass='icons8-refund-2'
                Heading={t('Paidouts')}
                DataPoint1={props.DP1}
                DataPoint3={props.DP2 + ' ' + t('Paidouts')}
            ></BaseDataGlance>
        </>
    );
}